@if (tooManyTargets()) {
  <IAlert>{{ description() }}</IAlert>
}
